import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Row,
  Col,
} from 'reactstrap';

import { UploadFile, FetchFile } from './utils/DataFetch';
import { GetCookie, openFileInNewTab } from './utils/Common';

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

const moment = require('moment');

export class WorkOrderPrintPreview extends Component {
  static displayName = WorkOrderPrintPreview.name;
  constructor(props) {
    super(props);
    this.state = {
      model: this.props.model,
      alert: this.props.alert,
      sortModel: {
        SortBy: 'jobDateTime',
        SortDirection: 'desc',
      },
      pdfRequested: false,
    };
    //
    this.user = JSON.parse(GetCookie('user'));
    this.printWorkOrder = this.printWorkOrder.bind(this);
    this.fetchPdfOnLoad = this.fetchPdfOnLoad.bind(this);
    this.handleBrowserPrint = this.handleBrowserPrint.bind(this);
  }

  componentDidMount() {
    const woFormEl = document.getElementById('woForm');
    if (woFormEl) {
      woFormEl.className += ' noPrint';
    }
    // Attempt initial PDF fetch (may defer if JobId not yet ready)
    this.fetchPdfOnLoad();
  }

  componentDidUpdate(prevProps, prevState) {
    // If model updated with JobId and we haven't fetched yet, try again
    const currentJobId = this.props.model?.JobId || this.state.model?.JobId;
    const prevJobId = prevProps.model?.JobId || prevState.model?.JobId;
    if (
      !this.state.pdfRequested &&
      currentJobId &&
      prevJobId !== currentJobId
    ) {
      this.fetchPdfOnLoad();
    }
  }

  async fetchPdfOnLoad() {
    if (this.state.pdfRequested) return; // already done
    const modelRef = this.props.model || this.state.model;
    if (!modelRef?.JobId || !this.user) return; // wait until data ready
    this.setState({ pdfRequested: true });
    const printedBy = `${this.user.firstname} ${this.user.lastname}`.trim();
    const url = '/printworkorderpdf';
    const body = {
      JobId: modelRef.JobId,
      PrintedBy: printedBy,
    };
    const itemFileName = `WorkOrder_${modelRef.JobNum}.pdf`;
    await FetchFile(url, 'POST', this.user.token, body)
      .then((blob) => {
        if (!blob || blob.size === 0) {
          alert('No file returned.');
          return;
        }
        openFileInNewTab(blob, itemFileName);
        this.printWorkOrder();
      })
      .catch((err) => {
        console.error('Failed to generate/save Work Order PDF:', err);
        alert('No file returned.');
      });
  }

  printWorkOrder() {
    var formData = new FormData();
    formData.append('EventType', 'insert');
    formData.append('JobHistoryId', null);
    formData.append('JobId', this.state.model.JobId);
    formData.append('Description', 'Work Order Printed');
    formData.append('JobHistoryType', 'Printed');
    formData.append('CreateByUserId', this.user.userid);

    UploadFile('/savejobhistory', this.user.token, formData);
  }

  handleBrowserPrint() {
    window.print();
  }

  render() {
    const jobDateTimeValue =
      this.state.model?.JobDateTime || this.state.model?.jobDateTime;
    const jobTimeValue = this.state.model?.JobTime || this.state.model?.jobTime;

    const parsedJobDateTime = jobDateTimeValue ? moment(jobDateTimeValue) : null;
    const formattedJobDay =
      parsedJobDateTime && parsedJobDateTime.isValid()
        ? parsedJobDateTime.format('dddd')
        : '';
    const formattedJobDate =
      parsedJobDateTime && parsedJobDateTime.isValid()
        ? parsedJobDateTime.format('MM/DD/YYYY')
        : '';

    let formattedJobTime = '';
    if (jobTimeValue) {
      const parsedJobTime = moment(
        String(jobTimeValue).trim(),
        [
          'h:mm A',
          'hh:mm A',
          'h:mmA',
          'hh:mmA',
          'h:mm:ss A',
          'hh:mm:ss A',
          'H:mm',
          'HH:mm',
          'H:mm:ss',
          'HH:mm:ss',
          'HH:mm:ss.SSS',
          'HH:mm:ss.SSSSSSS',
        ],
        true,
      );
      if (parsedJobTime.isValid()) {
        formattedJobTime = parsedJobTime.format('hh:mm A');
      }
    }
    if (!formattedJobTime && parsedJobDateTime && parsedJobDateTime.isValid()) {
      formattedJobTime = parsedJobDateTime.format('hh:mm A');
    }

    return (
      <div>
        <style>{`
          .wo-print-page {
            width: 100%;
          }

          @media print {
            @page {
              size: Letter portrait;
              margin: 0.5in;
            }

            html,
            body {
              width: 8.5in;
              min-height: 11in;
              margin: 0 !important;
              padding: 0 !important;
              background: #fff !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            body * {
              visibility: hidden;
            }

            .wo-print-modal,
            .wo-print-modal * {
              visibility: visible;
            }

            .wo-print-modal {
              position: static !important;
              display: block !important;
              overflow: visible !important;
            }

            .wo-print-modal .modal-dialog {
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 !important;
            }

            .wo-print-modal .modal-content {
              border: 0 !important;
              box-shadow: none !important;
              margin: 0 !important;
            }

            .wo-print-modal .modal-header,
            .wo-print-modal .modal-footer {
              display: none !important;
            }

            .wo-print-modal .modal-body {
              max-height: none !important;
              overflow: visible !important;
              padding: 0 !important;
            }

            .wo-print-page {
              width: 7.5in;
              margin: 0 auto;
              font-size: 10.5pt;
              line-height: 1.2;
            }

            .wo-print-page table {
              width: 100% !important;
              table-layout: fixed;
            }

            .wo-print-page tr,
            .wo-print-page td,
            .wo-print-page th,
            .wo-print-page .row {
              break-inside: avoid;
              page-break-inside: avoid;
            }
          }
        `}</style>
        <Modal
          id="divcontents"
          className="printable wo-print-modal"
          isOpen={this.props.modal}
          toggle={this.props.setModal}
          style={{ width: '1024px' }}
        >
          <ModalHeader>Executive Linguist Agency</ModalHeader>
          <ModalBody
            id="divBody"
            /* Allow vertical scroll when content exceeds available space */
            style={{
              maxHeight: '70vh',
              overflowY: 'auto',
              overflowX: 'hidden',
              paddingRight: '12px',
            }}
          >
            <div className="wo-print-page">
            <Row>
              <Col className="col-4">
                Executive Linguist Agency, Inc <br /> Ph: 800-522-2320 Fax:
                310-376-9285
              </Col>
              <Col className="col-4">mail@executivelinguist.com</Col>
              <Col className="col-4">
                <InputGroup size="sm">
                  <InputGroupText size="sm text-area-no-background">
                    CLAIMANT:
                  </InputGroupText>
                  <span
                    style={{ paddingTop: '7px' }}
                    className="form-control-text"
                  >
                    {this.state.model.ClmLastName},{' '}
                    {this.state.model.ClmFirstName}
                  </span>
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col className="col-4"></Col>
              <Col className="col-4"></Col>
              <Col className="col-4">
                <InputGroup size="sm">
                  <InputGroupText size="sm">JOB/INV NO:</InputGroupText>
                  <span
                    style={{ paddingTop: '7px' }}
                    className="form-control-text"
                  >
                    {this.state.model.JobNum}
                  </span>
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col className="col-12">
                <center>
                  <h4>WORK ORDER</h4>
                </center>
              </Col>
            </Row>
            <br />
            {/* Typography: labels normal, values bold for all fields below */}
            <style>{`
              .wo-bold-values .input-group-text { font-weight: 400 !important; }
              /* Ensure values are bold despite global .form-control-text !important font */
              .wo-bold-values .form-control-text { font-weight: 700 !important; }
            `}</style>
            <div className="wo-bold-values">
              <Row>
                <Col className="col-3">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">Created On:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {moment(this.state.model.CreateDateTime).format(
                        'MM/DD/YYYY'
                      )}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-3">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">Created By:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.CreatedBy}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-2">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">Printed By:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.user.firstname} {this.user.lastname}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-8">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">CALLER:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.CallerNote}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">
                      <input type="checkbox"></input> &nbsp; INTERPRETER:
                    </InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.IntLastName},{' '}
                      {this.state.model.IntFirstName}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-4"></Col>
                <Col className="col-4"></Col>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">PHONE:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.IntPhoneOnly}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">ADJUSTER:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.RepLastName},{' '}
                      {this.state.model.RepFirstName}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">PHONE:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.RepPhone}
                    </span>
                  </InputGroup>
                </Col>
                {/* spacer to push Fee to the right */}
                <Col className="col-4"></Col>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">FEE:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {Number(this.state.model.IntFee) !== 0
                        ? this.state.model.IntFee
                        : ''}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">ABBRV:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClientAbbrv}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-2">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">DAY:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {formattedJobDay}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-2">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">DATE:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {formattedJobDate}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-2">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">TIME:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {formattedJobTime}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">APPOINTMENT:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ProviderName}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">Job Type:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.JobTypeName}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">NAME:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.AptName}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">STREET:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.AptStreet}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-2">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">CITY:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.AptCity}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-2">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">STATE:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.AptState}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-2">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">ZIP:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.AptZip}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">PHONE:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.AptPhone}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">EXTRA INFO:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.AptDirection}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">CLAIMANT:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmLastName},{' '}
                      {this.state.model.ClmFirstName}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">
                      <input type="checkbox"></input> &nbsp; LANGUAGE:
                    </InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmLanguage}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">CLM PHONE:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmPhone}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">CLM NO:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmClaimNumber}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">DATE OF INJURY:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmDateOfInjury}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">DATE OF LOSS:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmDateOfLossDate
                        ? moment(this.state.model.ClmDateOfLossDate).format('MM/DD/YYYY')
                        : this.state.model.ClmDateOfLoss}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">EMPLOYER:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmEmployer === ''
                        ? 'n/a'
                        : this.state.model.ClmEmployer}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">INSURED:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmInsuredParty}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">DOB:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmDOB === null
                        ? null
                        : moment(this.state.model.ClmDOB).format('MM/DD/YYYY')}
                    </span>
                  </InputGroup>
                </Col>
                <Col className="col-4">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">CAPTION:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmInvoiceCaption}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">WCAB #:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmWCABNumber}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="col-12">
                  <InputGroup size="sm">
                    <InputGroupText size="sm">Claimant Notes:</InputGroupText>
                    <span
                      style={{ paddingTop: '7px' }}
                      className="form-control-text"
                    >
                      {this.state.model.ClmNote}
                    </span>
                  </InputGroup>
                </Col>
              </Row>
              <br></br>
              <Row>
                <Col>
                  <Table
                    striped
                    size="sm"
                    className="table-bordered table-striped"
                    hover
                    style={{
                      tableLayout: 'fixed',
                      lineHeight: '8px',
                      alignItems: 'center',
                      padding: '0.3rem 0.3rem 0.1rem 0.3rem',
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell width="145px">Type</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell width="170px">CreatedBy</TableCell>
                        <TableCell width="165px">Date</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.props.jobHistoryList.map((jobhistory, i) => (
                        <tr key={jobhistory.jobHistoryId}>
                          <td className="x-grid-cell-inner">
                            {jobhistory.jobHistoryType}
                          </td>
                          <td className="x-grid-cell-inner">
                            {jobhistory.description}
                          </td>
                          <td className="x-grid-cell-inner">
                            {jobhistory.createdBy}
                          </td>
                          <td className="x-grid-cell-inner">
                            {moment(jobhistory.createDateTime).format(
                              'MM/DD/YYYY hh:mm A'
                            )}
                          </td>
                        </tr>
                      ))}
                    </TableBody>
                  </Table>
                </Col>
              </Row>
            </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              ref={(Button) => (this.btnPrint = Button)}
              className="btn-secondary-no-background form-control-text btn btn-secondary btn-sm"
              onClick={this.handleBrowserPrint}
            >
              Print
            </Button>
            <Button
              className="btn btn-secondary btn-sm"
              onClick={this.props.setModal}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
